import { render, staticRenderFns } from "./StudentSelfStudy.vue?vue&type=template&id=9faff5d6&scoped=true&"
import script from "./StudentSelfStudy.vue?vue&type=script&lang=js&"
export * from "./StudentSelfStudy.vue?vue&type=script&lang=js&"
import style0 from "./StudentSelfStudy.vue?vue&type=style&index=0&id=9faff5d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9faff5d6",
  null
  
)

export default component.exports